import React, { useContext, useState } from "react";
import { useNavigate } from "react-router";
import "../../stylesheet/component.css";
import "../../stylesheet/forms.css";
import { useSearchParams } from "react-router-dom";
import { addBilling, editBilling } from "../../Utils/localStore";
import ToastContext from "../../context/toasterContex";
import dateFormatter from "../../Utils/dateFormatter";

const InventorySummary = ({ data, goBack }) => {
  const { toast } = useContext(ToastContext);
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const queryParams = searchParams.get("mode");
  const edit = queryParams;
  let today = Date.now();
  const calTotal = () => {
    let total = 0;
    data?.items.forEach((item) => {
      return (total += +item.amount);
    });
    return total;
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!edit) {
      const newBilling = { ...data, date: today, status: "Unpaid" };
      await addBilling(newBilling)
        .then((resp) => {
          toast.success("Invoice Added successfully", {
            position: toast.POSITION.TOP_CENTER,
          });
          navigate("/billings");
        })
        .catch((err) => {
          toast.error("Something went wrong, please try again later", {
            position: toast.POSITION.TOP_CENTER,
          });
          throw new Error(err);
        });
    } else {
      await editBilling(data)
        .then((resp) => {
          toast.success("Invoice updated successfully", {
            position: toast.POSITION.TOP_CENTER,
          });
          navigate("/billings");
        })
        .catch((err) => {
          toast.error("Something went wrong, please try again later", {
            position: toast.POSITION.TOP_CENTER,
          });
          throw new Error(err);
        });
    }
  };
  return (
    <div className="relative w-full font-euclid-circular-a">
      <div>
        <h1 className="text-sky-500 text-3xl  pt-10 font-bold font-euclid-circular-a ">
          Billing Summary
        </h1>
        <p className="pt-10">
          Review all inventory information before confirming entry.
        </p>
      </div>

      <div className="flex justify-center gap-5">
        <section className="bg-white text-gray-900 w-4/5">
          <div className="mx-auto">
            <div className="mb-8 text-left">
              <h1 className="text-4xl font-bold text-primary">Pharmanager</h1>
            </div>

            <div className="flex justify-between items-center mb-8">
              <div>
                <h2 className="text-2xl font-bold text-primary">INVOICE</h2>
                <p className="text-sm text-primary">
                  INVOICE NO: PM-{data?.localID || "-"}-
                  {data?.userLocalId || "-"}
                </p>
              </div>
              <div className="text-right">
                <p className="text-sm">
                  <span className="font-bold capitalize">ISSUE DATE:</span> {dateFormatter(data?.date)}
                </p>
                <p className="text-sm">
                  <span className="font-bold">DUE DATE:</span>{" "}
                  {data?.dueDate || "-"}
                </p>
              </div>
            </div>

            <div className="flex justify-between mb-8">
              <div>
                <h3 className="text-lg font-bold text-primary">
                  DOCTORS DETAILS:
                </h3>
                <p>Dr. John Doe</p>
                <p>Resident Doctor In Charge</p>
                <p>MD 25320</p>
              </div>
              <div className="text-right">
                <h3 className="text-lg font-bold text-primary">
                  PATIENTS/COMPANY DETAILS:
                </h3>
                <p className="capitalize">
                  {data?.user?.patientName ?? data?.name}
                </p>
                <p className="capitalize">{data?.user?.address}</p>
                <p className="capitalize">{data?.user?.contactDetails}</p>
              </div>
            </div>

            <table className="min-w-full bg-white border border-primary">
              <thead>
                <tr>
                  <th className="py-2 px-4 border-2 border-  border-primary">
                    S/N
                  </th>
                  <th
                    colSpan={3}
                    className="py-2 px-4 border-2  border-primary"
                  >
                    Item Description
                  </th>
                  <th className="py-2 px-4 border-2  border-primary">
                    Rate (₦)
                  </th>
                  <th className="py-2 px-4 border-2  border-primary">
                    Amount (₦)
                  </th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              {
                <tbody>
                  {data &&
                    data?.items.map((item, index) => (
                      <tr
                        key={index + "WestCoats"}
                        className="border-2 border-primary"
                      >
                        <td className="py-2 px-4 border-2  border-primary text-center">
                          {index + 1}
                        </td>
                        <td
                          className="capitalize py-2 px-4 border-2  border-primary"
                          colSpan={3}
                        >
                          {item.description ?? item.name} X {item.count}
                        </td>
                        <td className="py-2 px-4 border-2  border-primary text-right">
                          {item.amount ?? item.price}
                        </td>
                        <td className="py-2 px-4 border-2  border-primary text-right">
                          {item.amount ?? item.price * item.count}
                        </td>
                      </tr>
                    ))}
                  <tr className="border-2 border-primary">
                    <td className="py-2 px-4 border-2  border-primary text-center">
                      {""}
                    </td>
                    <td
                      className="py-2 px-4 border-2  border-primary"
                      colSpan={3}
                    >
                      {""}
                    </td>
                    <td className="py-2 px-4 border-2  border-primary text-right font-bold">
                      Total
                    </td>
                    <td className="py-2 px-4 border-2  border-primary text-right">
                      {data?.total ?? calTotal()}
                    </td>
                  </tr>
                </tbody>
              }
            </table>

            <div className="mt-16 flex justify-end">
              <div className="text-center">
                <p className="font-bold">DOCTORS SIGNATURE</p>
                <p className="mt-4">
                  signature
                  {/* <img src="signature.png" alt="Signature" className="inline-block"></p> */}
                </p>
                <p className="font-bold">John Doe</p>
              </div>
            </div>
          </div>
        </section>
        <div className="w-1/5">
          {/* onClick={goBack} */}
          <button
            onClick={goBack}
            type="button"
            className="border-primary border p-2 rounded min-w-40"
          >
            Edit
          </button>
          <div className="my-3">
            {edit ? (
              <button
                onClick={handleFormSubmit}
                type="button"
                className="rounded text-white bg-primary p-2 min-w-40"
              >
                Update
              </button>
            ) : (
              <button
                onClick={handleFormSubmit}
                type="button"
                className="rounded text-white bg-primary p-2 min-w-40"
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default InventorySummary;
